import React from "react";
import makeStyles from "@mui/styles/makeStyles";

import Container from "@mui/material/Container";
import SmallUserProfile from "../components/SmallUserProfile";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/material";

const useStyles = makeStyles(theme => ({
  header: {
    paddingLeft: 60,
    [theme.breakpoints.up("xl")]: {
      paddingLeft: 0,
    },
  },
}));

const ApplicationHeader = props => {
  const { applicationNavigation } = props;
  const classes = useStyles();

  return (
    <Container className={classes.header} disableGutters>
      <Box mb={4}>
        <Grid container justifyContent="space-between" alignItems="center">
          {applicationNavigation ? (
            <Grid item sm={true}>
              {applicationNavigation}
            </Grid>
          ) : (
            <Box>{/*  Empty div to fill navigation space */}</Box>
          )}

          <Grid item>
            <SmallUserProfile />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default ApplicationHeader;
